/* @ngInject */

export default () => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceSearchProduct(
    idLenders,
    type,
    loanAmount,
    assetType,
    assetAge,
    loanTerm,
    productType,
    vendorType,
    loanType,
    likeForLike,
    changeToEntityAllowed,
    elapsedTimeFromPayout,
    elapsedTermOldLoan,
    increaseInRepayment,
    balloonValue,
    balloonPercent,
    brokerOriginationFee,
    brokerCommissionValue,
    brokerCommissionPercent,
    lvrLvt,
    integrationLvrLvt,
    abnRegistered,
    gstRegistered,
    employmentBasis,
    creditHistory,
    homeOwnership,
    timeAtCurrentAddress,
    creditScore,
    creditReference,
    timeInEmployment,
    financedFees,
    bankrupts,
    utilityAndTelCo,
    financialDefaults,
    borrowerOnVisa,
    paygAndNoAbn,
    payDayEnquires,
    payDayOnStatements,
    financedInsurance,
    depositRequired,
    maxNegativeEquity,
    applicantAge,
    prestigeCars,
    eeef,
    greyImports,
    isNew
  ) {
    this.idLenders = idLenders;
    this.type = type;
    this.loanAmount = loanAmount;
    this.assetType = assetType;
    this.assetAge = assetAge;
    this.loanTerm = loanTerm;
    this.productType = productType;
    this.vendorType = vendorType;
    this.loanType = loanType;
    this.likeForLike = likeForLike;
    this.changeToEntityAllowed = changeToEntityAllowed;
    this.elapsedTimeFromPayout = elapsedTimeFromPayout;
    this.elapsedTermOldLoan = elapsedTermOldLoan;
    this.increaseInRepayment = increaseInRepayment;
    this.balloonValue = balloonValue;
    this.balloonPercent = balloonPercent;
    this.brokerOriginationFee = brokerOriginationFee;
    this.brokerCommissionValue = brokerCommissionValue;
    this.brokerCommissionPercent = brokerCommissionPercent;
    this.lvrLvt = lvrLvt;
    this.integrationLvrLvt = integrationLvrLvt;
    this.abnRegistered = abnRegistered;
    this.gstRegistered = gstRegistered;
    this.employmentBasis = employmentBasis;
    this.creditHistory = creditHistory;
    this.homeOwnership = homeOwnership;
    this.timeAtCurrentAddress = timeAtCurrentAddress;
    this.creditScore = creditScore;
    this.creditReference = creditReference;
    this.timeInEmployment = timeInEmployment;
    this.financedFees = financedFees;
    this.bankrupts = bankrupts;
    this.utilityAndTelCo = utilityAndTelCo;
    this.financialDefaults = financialDefaults;
    this.borrowerOnVisa = borrowerOnVisa;
    this.paygAndNoAbn = paygAndNoAbn;
    this.payDayEnquires = payDayEnquires;
    this.payDayOnStatements = payDayOnStatements;
    this.financedInsurance = financedInsurance;
    this.depositRequired = depositRequired;
    this.maxNegativeEquity = maxNegativeEquity;
    this.applicantAge = applicantAge;
    this.prestigeCars = prestigeCars;
    this.eeef = eeef;
    this.greyImports = greyImports;
    this.isNew = isNew;

    if (this.integrationLvr === undefined) {
      this.integrationLvr = 0;
    }
    if (this.applicantAge === undefined) {
      this.applicantAge = 0;
    }
    if (this.prestigeCars === undefined) {
      this.prestigeCars = 'NOT_ESSENTIAL';
    }
    if (this.eeef === undefined) {
      this.eeef = 'NOT_ESSENTIAL';
    }
    if (this.greyImports === undefined) {
      this.greyImports = 'NOT_ESSENTIAL';
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceSearchProduct.Blank = function () {
    return AssetFinanceSearchProduct.Build({
      idLenders: [],
      type: 'ASSET_FINANCE',
      loanAmount: 0,
      assetType: 0,
      assetAge: -1,
      loanTerm: 0,
      productType: 0,
      vendorType: 0,
      loanType: '',
      likeForLike: 'NOT_ESSENTIAL',
      changeToEntityAllowed: 'NOT_ESSENTIAL',
      elapsedTimeFromPayout: 'NOT_ESSENTIAL',
      elapsedTermOldLoan: 'NOT_ESSENTIAL',
      increaseInRepayment: 'NOT_ESSENTIAL',
      balloonValue: 0,
      balloonPercent: 0,
      brokerOriginationFee: 0,
      brokerCommissionValue: 0,
      brokerCommissionPercent: 0,
      lvrLvt: 0,
      integrationLvrLvt: 0,
      abnRegistered: -1,
      gstRegistered: -1,
      employmentBasis: 'NOT_ESSENTIAL',
      creditHistory: 'NOT_ESSENTIAL',
      homeOwnership: 'NOT_ESSENTIAL',
      timeAtCurrentAddress: 'NOT_ESSENTIAL',
      creditScore: 0,
      creditReference: 'NOT_ESSENTIAL',
      timeInEmployment: 'NOT_ESSENTIAL',
      financedFees: 'NOT_ESSENTIAL',
      bankrupts: 'NOT_ESSENTIAL',
      utilityAndTelCo: 'NOT_ESSENTIAL',
      financialDefaults: 'NOT_ESSENTIAL',
      borrowerOnVisa: 'NOT_ESSENTIAL',
      paygAndNoAbn: 'NOT_ESSENTIAL',
      payDayEnquires: 'NOT_ESSENTIAL',
      payDayOnStatements: 'NOT_ESSENTIAL',
      financedInsurance: 'NOT_ESSENTIAL',
      depositRequired: 'NOT_ESSENTIAL',
      maxNegativeEquity: 'NOT_ESSENTIAL',
      applicantAge: 0,
      prestigeCars: 'NOT_ESSENTIAL',
      eeef: 'NOT_ESSENTIAL',
      greyImports: 'NOT_ESSENTIAL',
      isNew: true
    });
  };

  AssetFinanceSearchProduct.Build = function (data) {
    return new AssetFinanceSearchProduct(
      data.idLenders ? data.idLenders : [],
      data.type ? data.type : 'ASSET_FINANCE',
      data.loanAmount ? data.loanAmount : 0,
      data.assetType ? data.assetType : 0,
      data.assetAge || data.assetAge === 0 ? data.assetAge : -1,
      data.loanTerm ? data.loanTerm : 0,
      data.productType ? data.productType : 0,
      data.vendorType ? data.vendorType : 0,
      data.loanType ? data.loanType : '',
      data.likeForLike ? data.likeForLike : 'NOT_ESSENTIAL',
      data.changeToEntityAllowed ? data.changeToEntityAllowed : 'NOT_ESSENTIAL',
      data.elapsedTimeFromPayout ? data.elapsedTimeFromPayout : 'NOT_ESSENTIAL',
      data.elapsedTermOldLoan ? data.elapsedTermOldLoan : 'NOT_ESSENTIAL',
      data.increaseInRepayment ? data.increaseInRepayment : 'NOT_ESSENTIAL',
      data.balloonValue ? data.balloonValue : 0,
      data.balloonPercent ? data.balloonPercent : 0,
      data.brokerOriginationFee ? data.brokerOriginationFee : 0,
      data.brokerCommissionValue ? data.brokerCommissionValue : 0,
      data.brokerCommissionPercent ? data.brokerCommissionPercent : 0,
      data.lvrLvt ? data.lvrLvt : 0,
      data.integrationLvrLvt ? data.integrationLvrLvt : 0,
      data.abnRegistered || data.abnRegistered === 0 ? data.abnRegistered : -1,
      data.gstRegistered || data.gstRegistered === 0 ? data.gstRegistered : -1,
      data.employmentBasis ? data.employmentBasis : 'NOT_ESSENTIAL',
      data.creditHistory ? data.creditHistory : 'NOT_ESSENTIAL',
      data.homeOwnership ? data.homeOwnership : 'NOT_ESSENTIAL',
      data.timeAtCurrentAddress ? data.timeAtCurrentAddress : 'NOT_ESSENTIAL',
      data.creditScore ? data.creditScore : 0,
      data.creditReference ? data.creditReference : 'NOT_ESSENTIAL',
      data.timeInEmployment ? data.timeInEmployment : 'NOT_ESSENTIAL',
      data.financedFees ? data.financedFees : 'NOT_ESSENTIAL',
      data.bankrupts ? data.bankrupts : 'NOT_ESSENTIAL',
      data.utilityAndTelCo ? data.utilityAndTelCo : 'NOT_ESSENTIAL',
      data.financialDefaults ? data.financialDefaults : 'NOT_ESSENTIAL',
      data.borrowerOnVisa ? data.borrowerOnVisa : 'NOT_ESSENTIAL',
      data.paygAndNoAbn ? data.paygAndNoAbn : 'NOT_ESSENTIAL',
      data.payDayEnquires ? data.payDayEnquires : 'NOT_ESSENTIAL',
      data.payDayOnStatements ? data.payDayOnStatements : 'NOT_ESSENTIAL',
      data.financedInsurance ? data.financedInsurance : 'NOT_ESSENTIAL',
      data.depositRequired ? data.depositRequired : 'NOT_ESSENTIAL',
      data.maxNegativeEquity ? data.maxNegativeEquity : 'NOT_ESSENTIAL',
      data.applicantAge ? data?.applicantAge : 0,
      data.prestigeCars ? data?.prestigeCars : 'NOT_ESSENTIAL',
      data.eeef ? data?.eeef : 'NOT_ESSENTIAL',
      data.greyImports ? data?.greyImports : 'NOT_ESSENTIAL',
      data.isNew
    );
  };

  return AssetFinanceSearchProduct;
};
